import { render, staticRenderFns } from "./recharge_account.vue?vue&type=template&id=64d6cf88&scoped=true&"
import script from "./recharge_account.vue?vue&type=script&lang=js&"
export * from "./recharge_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6cf88",
  null
  
)

export default component.exports